module.exports = __webpack_public_path__ + "img/livePEN-box.8ee7fa9a.png";